module.exports = __webpack_public_path__ + "static/media/planning_title@2x.64ace035.png";